import React from 'react';
import { CTAButton } from './CTAButton';
const ITEMS = [{
  emoji: '😰',
  text: 'Tienes frente a ti un paciente con obesidad y no estás completamente seguro de cuál es el tratamiento más adecuado según su perfil clínico.'
}, {
  emoji: '⏱️',
  text: 'Pierdes demasiado tiempo consultando guías, consensos o artículos para confirmar una decisión que necesitas tomar en ese momento.'
}, {
  emoji: '🤔',
  text: 'Cuando el paciente no responde al tratamiento, dudas sobre si debes aumentar la dosis, cambiar el medicamento o modificar la estrategia.'
}, {
  emoji: '📋',
  text: 'Te gustaría tener una metodología clara para evaluar a todos tus pacientes sin olvidar ningún estudio o criterio importante.'
}, {
  emoji: '💬',
  text: 'Algunos pacientes abandonan el tratamiento porque no comprenden qué esperar o pierden la motivación durante el seguimiento.'
}, {
  emoji: '💉',
  text: 'Quieres prescribir con mayor seguridad medicamentos como semaglutida o tirzepatida, pero todavía tienes dudas sobre indicaciones, titulación y seguimiento.'
}];
export function PainPoints() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white" data-id="element-172" data-mp="1u1bx7i55re23">
      <div className="mx-auto max-w-3xl" data-id="element-173" data-mp="27rxfp5qp9lzg">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight sm:text-4xl" data-id="element-174" data-mp="27ute0v6gmcof">
          ¿Te identificas con alguna de estas situaciones?
        </h2>
        <p className="mt-3 text-center text-[15px] text-white/60" data-id="element-175" data-mp="1g2ch4yvpo7hj">
          Si respondiste “sí” a una de ellas, este Kit fue creado para ti.
        </p>

        <ul className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-176" data-mp="1p28wub04hw0g">
          {ITEMS.map(item => <li key={item.emoji} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.06] p-4" data-id="element-177" data-mp="1k3nyyi8cfof6">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-178" data-mp="30g33y2gypt41">
                {item.emoji}
              </span>
              <p className="text-[14px] leading-relaxed text-white/85" data-id="element-179" data-mp="2vkxfox0382cs">{item.text}</p>
            </li>)}
        </ul>

        <div className="mt-9 rounded-2xl border border-gold/30 bg-gold/10 p-5 text-center" data-id="element-180" data-mp="1y3qc4bftxnmi">
          <p className="text-[15px] font-semibold leading-relaxed text-white sm:text-lg" data-id="element-181" data-mp="2263662l7rx3g">
            La buena noticia es que ya no necesitas memorizar cientos de páginas de guías clínicas.
          </p>
          <p className="mt-2 text-[14px] leading-relaxed text-white/70" data-id="element-182" data-mp="1af747x0ozcuy">
            Solo necesitas seguir una Ruta Clínica diseñada para ayudarte a tomar mejores decisiones
            desde la primera consulta.
          </p>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-183" data-mp="1jdsjnjavabri">
          <CTAButton label="QUIERO DECIDIR CON SEGURIDAD" sublabel="Descarga inmediata · Garantía de 7 días" pulse={false} onDark data-id="element-184" data-mp="1o5sewyfzsghr" />
        </div>
      </div>
    </section>;
}